<template>
  <ContentLayout
    widthClass="max-1000"
    pad="0"
    :initData="ShiftPGData"
    @change="(changed) => (isChanged = changed)"
    :checkData="[
      'shift_property_group_name',
      'shift_property_group_description',
      'shift_property_group_code',
      'remarks',
    ]"
    :title="$t('label_essweb_shiftPropertyGroup_form_newTitle')"
  >
    <!-- content -->
    <template v-slot:page-main>
      <Stepper :curStep="curStep" :items="stepper">
        <template v-slot:content-1>
          <v-form ref="form" lazy-validation>
            <v-row justify="start" class="white lighten-5">
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <inputTextFiledMultiLang
                  :bindData="ShiftPGData.shift_property_group_name"
                  maxlength="100"
                  @change="
                    (valueArr) => {
                      ShiftPGData.shift_property_group_name = valueArr;
                    }
                  "
                  :label="
                    $t(
                      'label_essweb_shiftPropertyGroup_form_shiftPropertyGroupNameLabel'
                    )
                  "
                  :rules="$GetRules(['_Require_Rules'], [null])"
                />
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <inputTextFiledMultiLang
                  :bindData="ShiftPGData.shift_property_group_description"
                  maxlength="500"
                  @change="
                    (valueArr) => {
                      ShiftPGData.shift_property_group_description = valueArr;
                    }
                  "
                  :label="
                    $t('label_essweb_shiftPropertyGroup_form_descriptionLabel')
                  "
                />
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <normalInputTextFiled
                  :rules="$GetRules(['_Require_Rules'], [null])"
                  maxlength="100"
                  :label="
                    $t(
                      'label_essweb_shiftPropertyGroup_form_shiftPropertyGroupCodeLabel'
                    )
                  "
                  v-model="ShiftPGData.shift_property_group_code"
                />
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <v-sheet class="text--secondary">{{
                  $t("label_essweb_shiftPropertyGroup_form_remarkLabel")
                }}</v-sheet>
                <v-textarea
                  rows="5"
                  no-resize
                  maxlength="500"
                  filled
                  dense
                  counter="500"
                  single-line
                  v-model="ShiftPGData.remarks"
                  name="input-7-4"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </template>
        <template v-slot:content-2>
          <PropertyList
            :items="desserts"
            @edit="toEditProperty"
            :listdata="PropertyListData"
          />
        </template>
      </Stepper>
    </template>
    <!-- content -->
    <!-- actions -->
    <template v-slot:page-actions>
      <CardActions
        :newBtn="stepper.length == curStep && curStep != 0 ? true : false"
        :step="stepper.length == curStep ? false : true"
        @next="toNext"
        :preStep="curStep > 1 ? true : false"
        @pre="curStep = curStep - 1"
        @new="toAdd"
        @cancel="$toBack(isChanged)"
      />
    </template>
    <!-- actions -->
    <!-- tools -->
    <template v-slot:tools-main>
      <MappingPopup
        :show="showMappingPopup"
        :PropertyData="PropertyData"
        @close="
          showMappingPopup = false;
          PropertyData = null;
        "
        @confirm="onEditProperty"
      />
    </template>
    <!-- tools end -->
  </ContentLayout>
</template>
<script>
import MappingPopup from "@/Page/EssAdmin/Shift/ShiftPropertyGroup/components/MappingPopup";
import { mapGetters } from "vuex";
export default {
  name: "newShift",
  components: { MappingPopup },
  computed: {
    ...mapGetters(["companyLang", "staticZone"]),
  },
  watch: {},
  data() {
    return {
      changeListArr: [],
      isChanged: false,
      stepper: [
        "label_essweb_shiftPropertyGroup_form_step_generalLabel",
        "label_essweb_shiftPropertyGroup_form_step_propertyLabel",
      ],
      PropertyData: null,
      showMappingPopup: false,
      PropertyListData: null,
      curStep: 1,
      ShiftPGData: {
        shift_property_group_name: "",
        shift_property_group_description: "",
        shift_property_group_code: "",
        remarks: "",
      },
      desserts: [],
    };
  },
  mounted() {
    // this.ShiftPGData.shift_property_group_name = this.$getCommonLangKey(
    //   this.companyLang
    // );
    // this.ShiftPGData.shift_property_group_description = this.$getCommonLangKey(
    //   this.companyLang
    // );
    this.getPropertyList();
  },
  methods: {
    toNext: function () {
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.curStep = this.curStep + 1;
    },
    getPropertyList: function (type) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_shift_property",
        url: "/shift-property/get-shift-property-list/",
        data: {
          shift_property_group_uuid: "",
        },
      }).then((res) => {
        res.data.forEach((item) => {
          item["changeList"] = [];
          if (item.property_master_code.indexOf("|") != -1) {
            item["p_property_master_code"] =
              item.property_master_code.substring(
                0,
                item.property_master_code.lastIndexOf("|")
              );
          }
        });
        that.PropertyListData = res.data;
        that.desserts = that.$translateDataToTree(
          res.data,
          "property_master_code",
          "p_property_master_code"
        );
      });
    },
    onEditProperty: function (obj, x) {
      const that = this;
      this.findTreeItem(
        this.desserts,
        obj.property_master_code,
        obj["changeList"]
      );
      //超过三级刷新数据，不关闭弹窗
      if (x === undefined) this.showMappingPopup = false;
    },
    findTreeItem: function (tree, code, obj) {
      const that = this;
      tree.some((item) => {
        if (item["property_master_code"] === code) {
          item["changeList"] = obj;
          if (item["changeList"].length == 0) {
            item["value"] = "";
          }
          return true;
        } else {
          if (item.children) {
            that.findTreeItem(item.children, code, obj);
          } else {
          }
        }
      });
    },
    findTreeChange: function (tree) {
      const that = this;
      tree.map((item) => {
        if (item["changeList"])
          if (item["changeList"].length) {
            that.changeListArr.push(
              item["changeList"].filter(
                (ele) => ele.effective_utc_datetime !== "" && ele.value !== ""
              )
            );
          }
        if (item.children) {
          that.findTreeChange(item.children);
        }
      });
      that.changeListArr = Array.prototype.concat.apply([], that.changeListArr); // 数组降维
      that.changeListArr.every((it) => {
        if (it["actionid"]) delete it["actionid"];
      });
      return that.changeListArr;
    },
    toEditProperty: function (obj) {
      this.PropertyData = obj;
      this.showMappingPopup = true;
    },
    toAdd: function () {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      that.changeListArr = [];
      let arrlist = this.findTreeChange(this.desserts);
      this.$Request({
        method: "POST",
        table: "ess_att_shift_property_group",
        url: "/shift-property-group/add-shift-property-group-table/",
        data: {
          shift_property_group_name: this.$transCommonLangKey(
            this.ShiftPGData.shift_property_group_name
          ),
          shift_property_group_description: this.$transCommonLangKey(
            this.ShiftPGData.shift_property_group_description
          ),
          shift_property_group_code: this.ShiftPGData.shift_property_group_code,
          is_default: 0,
          remarks: this.ShiftPGData.remarks,
          ess_att_shift_property: arrlist,
        },
      }).then((res) => {
        that.$toBack();
      });
    },
  },
};
</script>
